import './basepage.scss'
import $ from 'jquery'
import './_reveal-it'
import '../../common/js/lazyload/lazyload'
import browserDetect from '../../common/js/browserdetect/browserdetect'

window.$ = $
browserDetect.addGlobalClasses()



// WEBPACK FOOTER //
// ./src/components/basepage/basepage.js